const ALL_USER_INITIAL_STATE = {
	allUsers: [],
};

export default ALL_USER_INITIAL_STATE;
